import { useState } from "react";
import { Icon } from "../ui/Icon";
import { SearchSelect } from "../ui/SearchSelect";
import { trpc } from "../../lib/trpc";

/** Sevkiyat satırında LOT İKAMESİ: planlanan lot yerine fiilen yüklenen lotu seç.
 *  Aday listesi sunucudan gelir (KATI kural: yalnız siparişe bağlı, released, SKT'si geçmemiş, bakiyesi olan).
 *  Aynı lotun birden çok deposu varsa her biri ayrı seçenektir → "hangi depodan yüklendi" de burada çözülür. */
export function LotSubstitutePicker({ lineId, onDone, onCancel }: { lineId: string; onDone: () => void; onCancel: () => void }) {
  const q = trpc.shipment.lineAssignableLots.useQuery({ lineId }, { staleTime: 3_000 });
  const mut = trpc.shipment.substituteLine.useMutation();
  const [sel, setSel] = useState<string>("");
  const [err, setErr] = useState<string | null>(null);

  // TR sayı biçimi (CLAUDE.md kural 4) — ham JS sayısı basma.
  const fmt = (n: number) => new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 3 }).format(n);
  const opts = (q.data?.lots ?? []).map((l) => ({
    value: `${l.lotId}|${l.locationId}`,
    label: `${l.lotCode} · ${l.locationCode} · ${fmt(l.available)}`,
  }));
  const current = q.data ? `${q.data.currentLotId}|${q.data.currentLocationId}` : "";

  async function apply() {
    const pick = sel || current;
    const [lotId, locationId] = pick.split("|");
    if (!lotId || !locationId) return;
    setErr(null);
    try {
      await mut.mutateAsync({ lineId, lotId, locationId });
      onDone();
    } catch (e) {
      setErr((e as Error).message);
    }
  }

  return (
    <div className="shp-sub">
      <div className="shp-sub-row">
        <SearchSelect
          value={sel || current}
          onChange={(v) => setSel(v ?? "")}
          options={opts}
          placeholder={q.isLoading ? "Lotlar yükleniyor…" : q.error ? "Lotlar alınamadı" : opts.length === 0 ? "Uygun lot yok" : "Lot · depo · bakiye"}
          disabled={q.isLoading || !!q.error || opts.length === 0}
        />
        <button type="button" className="btn-md primary shp-sub-btn" disabled={mut.isPending || q.isLoading} onClick={() => void apply()}>
          <Icon name="check" size={13} />{mut.isPending ? "…" : "Uygula"}
        </button>
        <button type="button" className="btn-md ghost shp-sub-btn" onClick={onCancel}><Icon name="x" size={13} />Vazgeç</button>
      </div>
      {q.error ? <div className="shp-sub-err" role="alert"><Icon name="alertTriangle" size={13} />Lot listesi alınamadı: {q.error.message}</div> : null}
      {err ? <div className="shp-sub-err" role="alert"><Icon name="alertTriangle" size={13} />{err}</div> : null}
    </div>
  );
}
